import { LinkButton } from '@library/components/buttons';
import { Loading } from '@library/components/Loading';
import { MemberDrawerHeader } from '@bo-components/members/drawer';
import { MemberPromotionDrawerContext } from '@bo-hooks/members';
import { MemberPromotionDrawerDetailsRow } from '@bo-components/members/memberPromotions/MemberPromotionDrawerDetailsRow';
import { useContext } from 'react';
import { useGetMemberPromotionQuery } from '@bo-services/members/memberPromotionsApi';

export const MemberPromotionDrawerDetails = () => {
  const {
    onClickEntryId,
    onClosePromotionsDrawer,
    memberId = '',
    promotionId
  } = useContext(MemberPromotionDrawerContext);

  const { data, isError, isFetching, isLoading } = useGetMemberPromotionQuery(
    {
      memberId,
      promotionId
    },
    { skip: !memberId || !promotionId }
  );

  if (isFetching || isLoading) {
    return (
      <div className="p-6">
        <Loading loadingMessage="Loading Promotion Details" />
      </div>
    );
  }

  if (isError) {
    <div className="p-6">
      <h1 className="text-roses m-auto text-xl font-bold">
        Error Fetching Member Promotions
      </h1>
    </div>;
  }

  if (!data) {
    return (
      <div className="p-6">
        <h1 className="text-soClean-100 m-auto text-xl font-bold">
          Invalid Member Promotion
        </h1>
      </div>
    );
  }

  const {
    communityPlayId,
    description,
    endDate,
    endTime,
    fundType,
    name,
    optIn,
    optedInAtDate,
    optedInAtTime,
    promotionId: promoId,
    promotionType,
    redeemedAtDate,
    redeemedAtTime,
    startDate,
    startTime,
    memberPromoWagerIds = []
  } = data;

  const memberPromoWagerId =
    memberPromoWagerIds.length > 0 ? memberPromoWagerIds[0].toString() : '';

  return (
    <>
      <MemberDrawerHeader onClose={onClosePromotionsDrawer}>
        <p className="text-soClean-100 leading-none">{promotionType}</p>
        <p
          className="text-soClean-180 text-sm"
          data-testid="promotion-drawer-header-name"
        >
          {name}
        </p>
      </MemberDrawerHeader>
      <div className="p-6">
        <MemberPromotionDrawerDetailsRow label="ID">
          {promoId}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Fund type">
          {fundType}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Start date">
          {`${startDate} ${startTime}`}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="End date">
          {`${endDate} ${endTime}`}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Opt in">
          {optIn ? 'true' : 'false'}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Opted in at">
          {`${optedInAtDate} ${optedInAtTime}`}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Redeemed at">
          {`${redeemedAtDate} ${redeemedAtTime}`}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Entry ID">
          {memberPromoWagerId && (
            <LinkButton
              label={memberPromoWagerId}
              onClick={() => {
                onClickEntryId({ entryId: memberPromoWagerId });
              }}
            />
          )}
        </MemberPromotionDrawerDetailsRow>
        <MemberPromotionDrawerDetailsRow label="Community play">
          {communityPlayId}
        </MemberPromotionDrawerDetailsRow>
        <div
          className="text-soClean-180 pb-1 text-sm"
          data-testid="promotion-drawer-label-description"
        >
          Description
        </div>
        <div
          className="text-soClean-120 text-sm"
          data-testid="promotion-drawer-description"
        >
          {description}
        </div>
      </div>
    </>
  );
};
